import React from "react";
import "./Portfolio.css";
import { portfolioData } from "../../data/portfolio.data";
import AnimatedHeadings from "../animatedHeadings/AnimatedHeadings";
import { motion } from "framer-motion";
import { motionProps, portfolioContainer } from "../../animations";
import ProjectCard from "./ProjectCard";

const Portfolio = () => {
  return (
    // <motion.section id="portfolio" variants={sectionVariants} {...motionProps}>
    <section id="portfolio">
      <AnimatedHeadings smallTitle="My Recent Work" mainTitle="Portfolio" />

      <motion.div
        className="container portfolio__container"
        variants={portfolioContainer}
        {...motionProps}
        // viewport={{ once: false, amount: 0.6 }}
      >
        {portfolioData
          .sort((a, b) => a.id - b.id)
          .map((item) => (
            <ProjectCard key={item.id} project={item} />
          ))}
      </motion.div>
    </section>
    // </motion.section>
  );
};

export default Portfolio;
